module.exports = __webpack_public_path__ + "img/icon-plus-w.4d827c83.svg";